<template>
  <div class="fan-run-status">
    <div class="fan-data">
      <div class="top-total">
        <div class="total-item">
          <div class="item_title">风机总数</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-total-new.png" alt="" />
            </div>
            <div class="content-num">
              <div class="value">{{ countMap.totalCount }}</div>
              <div class="text">台</div>
            </div>
          </div>
        </div>
        <div class="total-item">
          <div class="item_title">正常风机</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-run.png" alt="" />
            </div>
            <div class="content-num">
              <div class="value">
                {{ countMap.normalCount }}
              </div>
              <div class="text">台</div>
            </div>
          </div>
        </div>
        <div class="total-item">
          <div class="item_title">故障风机</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-broken.png" alt="" />
            </div>
            <div class="content-num">
              <div class="value">{{ countMap.faultCount }}</div>
              <div class="text">台</div>
            </div>
          </div>
        </div>
        <div class="total-item">
          <div class="item_title">运行风机</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-run.png" alt="" />
            </div>
            <div class="content-num">
              <div class="value">{{ countMap.onlineCount }}</div>
              <div class="text">台</div>
            </div>
          </div>
        </div>
        <div class="total-item">
          <div class="item_title">停止风机</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-out.png" alt="" />
            </div>
            <div class="content-num">
              <div class="value">{{ countMap.offlineCount }}</div>
              <div class="text">台</div>
            </div>
          </div>
        </div>
        <div class="total-item">
          <div class="item_title">风机运行率</div>
          <div class="item_content">
            <div class="content-icon">
              <img src="~@/common/assets/images/blower-rate.png" alt="" />
            </div>
            <div class="content-num">
              <span class="value"
                >{{
                  countMap.onlineCount && countMap.totalCount
                    ? (countMap.onlineCount / countMap.totalCount) * 100
                    : "0"
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fan-chart">
      <div class="fan-chart-left">
        <div class="container">
          <div class="container-header">
            <div class="container-line"></div>
            <div class="container-title">风机开关状态</div>
          </div>
          <div class="container-charts-box">
            <div id="barCharts" style="width: 100%; height: 100%"></div>
          </div>
        </div>
      </div>
      <div class="fan-chart-right">
        <div class="container">
          <div class="container-header">
            <div class="container-line"></div>
            <div class="container-title">风机状态</div>
          </div>
          <div class="container-desc">
            <div class="container-desc-line">
              <div>
                <img src="~@/common/assets/images/blower-run.png" alt="" />
              </div>
              <div class="text">运行</div>
              <div class="value">
                {{ countMap.onlineCount }}
              </div>
            </div>
            <div class="container-desc-line">
              <div class="status-img">
                <img src="~@/common/assets/images/blower-out.png" alt="" />
              </div>
              <div class="text">停止</div>
              <div class="value">
                {{ countMap.offlineCount }}
              </div>
            </div>
          </div>
          <div class="container-box">
            <div
              class="status-item"
              v-for="item in deviceStatusMap"
              :key="item.coldStorageNumberName"
            >
              <div class="content-icon" v-if="item.deviceStatusList.length">
                <img
                  class="status-img-dy"
                  v-if="item.deviceStatusList[0].currentStatusValue == '1'"
                  src="@/common/assets/images/blower-run.png"
                  alt=""
                />
                <img v-else src="~@/common/assets/images/blower-out.png" alt="" />
              </div>
              <div class="content-num">
                <span class="label">{{ item.coldStorageNumberName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eCharts from "echarts";
import { api } from "../api/api.js";
export default {
  data() {
    return {
      countMap: {},
      coldCount: {
        totalCount: 0,
        offlineCount: 0,
        onlineCount: 0,
        faultCount: 0,
      },
      coldMapKeyArr: [],
      offlineCountArr: [],
      onlineCountArr: [],
      totalCountArr: [],
      barCharts: null,
      barChartsOpt: null,
      deviceStatusMap: {},
      deviceKeys: [],
      coldCountMap: {},
    };
  },
  mounted() {
    this.getStatDevice().then((res) => {
      this.initChart(res);
    });
  },
  methods: {
    getStatDevice() {
      return new Promise((resolve, reject) => {
        let params = {
          deviceType: "24",
        };
        this.$fetch(api.statDeviceStatusByStatus, params).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
          }
          this.countMap = res.returnObj.countMap;
          this.deviceStatusMap = res.returnObj.deviceStatusMap;
          this.coldCountMap = res.returnObj.coldCountMap;
          for (let key in this.coldCountMap) {
            this.coldMapKeyArr.push(key);
            this.onlineCountArr.push(this.coldCountMap[key].onlineCount);
            this.offlineCountArr.push(this.coldCountMap[key].offlineCount);
            this.totalCountArr.push(
              Number(this.coldCountMap[key].onlineCount) +
                Number(this.coldCountMap[key].offlineCount) +
                1
            );
          }
          let obj = {
            coldMapKeyArr: this.coldMapKeyArr,
            onlineCountArr: this.onlineCountArr,
            offlineCountArr: this.offlineCountArr,
            totalCountArr: this.totalCountArr,
          };
          resolve(obj);
        });
      });
    },
    initChart(data) {
      let chartDom = document.getElementById("barCharts");
      let option = {
        legend: {
          top: 0,
          right: 0,
          icon: "circle",
          itemHeight: 15, // 修改icon图形大小
          itemGap: 24,
          textStyle: {
            fontSize: 12,
            color: "#333",
            padding: [4, 0, 0, 0], // 修改文字和图标距离
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          textStyle: {
            fontSize: 12,
          },
          formatter: function (params) {
            let msg = "运行风机：" + params[2].value + "  停止风机：" + params[3].value;
            return msg;
          },
        },
        grid: {
          top: 70,
          right: 0,
          bottom: 20,
          left: 30,
        },
        xAxis: [
          {
            data: data.coldMapKeyArr,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              show: true,
              fontSize: 14,
              color: "black",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "black",
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#182450",
              },
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              color: "black",
              show: true,
            },
          },
        ],
        series: [
          {
            // 真实数据
            data: data.onlineCountArr,
            //symbol标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond','pin','arrow', 'none' (默认为圆形)
            type: "pictorialBar", //指定类型
            symbolSize: [25, 10], //指定大小，[宽,高]
            symbolOffset: [0, -3], //位置偏移 [右，下] 负数反方向
            z: 12, // 层级（优先级展示）
            itemStyle: {
              color: "rgba(64,122,238)",
            },
            symbolPosition: "end",
          },
          {
            type: "pictorialBar",
            symbolSize: [25, 10],
            symbolOffset: [0, 3],
            z: 12,
            itemStyle: {
              color: "rgba(64,122,238)",
            },
            data: data.onlineCountArr,
            // 真实数据
            // data: data.offlineCountArr,
          },
          {
            name: "运行风机",
            type: "bar",
            barWidth: 25,
            // itemStyle: {},
            // z: 16,
            // silent: true,
            stack: "站点",
            // barWidth: 16,
            barGap: "-100%",
            showBackground: false,
            itemStyle: {
              // color: "rgb(67,106,2)",
              color: new eCharts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 表示从上到下
                [
                  { offset: 1, color: "rgba(64, 122, 238,0.6)" },
                  { offset: 0, color: "rgba(42, 85, 94,0.6)" },
                ]
              ),
            },
            label: {
              show: true,
              position: "left",
              color: "black",
              z: 99,
            },
            // backgroundStyle: {
            //   color: "rgba(243.153,35, 0.4)",
            // },
            // 真实数据
            // data: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            data: data.onlineCountArr,
          },
          {
            name: "停止风机",
            type: "bar",
            stack: "站点",
            // itemStyle: {},
            // z: 16,
            // silent: true,
            barWidth: 25,
            label: {
              show: true,
              position: "left",
              color: "black",
              z: 99,
            },
            barGap: "-100%",
            // showBackground: false,
            // color: "rgba(243.153,35, 0.4)",
            itemStyle: {
              // color: "rgb(67,106,2)",
              color: new eCharts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 表示从上到下
                [
                  { offset: 1, color: "rgba(147, 93, 21,0.6)" },
                  { offset: 0, color: "rgba(255, 206, 66,0.6)" },
                ]
              ),
            },
            // backgroundStyle: {
            //   color: "rgba(20,82,130, 0.4)",
            // },
            // 真实数据
            // data: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            data: data.offlineCountArr,
          },
          // {
          //   type: "pictorialBar",
          //   symbolSize: [25, 10],
          //   symbolOffset: [0, -6],
          //   z: 15,
          //   symbolPosition: "end",
          //   itemStyle: {
          //     color: "rgb(147,93,21)",
          //     opacity: 0.7,
          //   },
          //   data: data.totalCountArr,
          //   // 设置最大数据，可以不设置data，默认为真实数据的最大值
          //   // data: [500, 500, 500, 500, 500, 500, 500],
          // },
        ],
      };
      this.barCharts = eCharts.init(chartDom);
      this.barCharts.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.fan-run-status {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  .fan-data {
    width: 100%;
    height: auto;
    background-color: #ffffff;

    .top-total {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 20px 0;

      .total-item {
        width: 15%;
        height: 120px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-image: linear-gradient(rgba(6, 152, 172, 0.3), rgba(6, 101, 142, 0.3));
        padding: 20px;

        .item_title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .item_content {
          display: flex;

          .content-icon {
            margin-left: 8%;
          }

          .content-num {
            padding-left: 30%;
            display: flex;
            align-items: baseline;
            margin-top: 10px;

            .value {
              font-size: 26px;
              font-weight: bold;
            }

            .text {
              font-size: 15px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }

  .fan-chart {
    width: 100%;
    height: calc(100% - 180px);
    background-color: #ffffff;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;

    .fan-chart-left {
      width: 49%;
      height: 100%;
      margin: 16px 15px 0 16px;
      .container-charts-box {
        width: 100%;
        margin-top: 55px;
        // height: 480px;
        height: 82%;
      }
    }
  }

  .fan-chart-right {
    width: 49%;
    height: 100%;
    margin: 16px 16px 0 15px;

    .container-desc {
      width: 100%;
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;

      .container-desc-line {
        display: flex;
        align-items: center;

        .status-img {
          margin-left: 30px;
        }

        .text {
          margin-left: 15px;
        }

        .value {
          margin-left: 10px;
        }
      }
    }

    .container-box {
      width: 100%;
      // height: 495px;
      height: 85%;
      overflow-y: auto;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .status-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        background-image: linear-gradient(rgba(6, 152, 172, 0.3), rgba(6, 101, 142, 0.3));
        height: 50px;

        .status-img-dy {
          animation: imgRotate 2s linear infinite;
        }

        .content-num {
          margin-left: 10px;
        }
      }
    }
  }

  .container {
    width: 100%;
    height: 96%;
    border-radius: 8px;
    border: 2px solid rgba(64, 127, 255, 0.5);
    -webkit-box-shadow: 0 5px 5px rgba(64, 127, 255, 0.3) inset;
    box-shadow: inset 1px 1px 10px rgba(64, 127, 255, 0.3);
    padding: 20px;
  }

  .container-header {
    display: flex;

    .container-line {
      width: 10px;
      height: 30px;
      background-image: linear-gradient(rgba(6, 152, 172, 0.3), rgba(6, 101, 142, 0.3));
    }

    .container-title {
      height: 30px;
      line-height: 30px;
      font-size: 25px;
      margin-left: 10px;
    }
  }
}

@keyframes imgRotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
